import { useTrackNextActionsQuery } from "./track-next-actions-query.hook";

const useTrackNextActions = () => {
  const { data, isLoading, isError } = useTrackNextActionsQuery();

  return {
    data,
    isLoading,
    isError,
  };
};

export default useTrackNextActions;
